import React, { useMemo } from "react";
import GlobalNav from "../components/GlobalNav";
import Footer from "../components/Footer";
import SampleBreakdown from "../components/sampling/SampleBreakdown";
import "./SamplingPage.css";

// Was the original repo's bare /dev route -- a raw, publicly-reachable
// authoring tool for building new case study loop/marker data. Gated
// behind admin here, matching the pattern used everywhere else in this
// app, rather than left exposed at a guessable URL to any visitor.
export default function SamplingAuthoring() {
  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  }, []);
  const isAdmin = !!user?.admin;

  return (
    <div className="sampling-page">
      <GlobalNav activeHref="/sampling" ctaLabel="Join the collective" />
      <div className="sampling-page-inner sampling-authoring-inner">
        {isAdmin ? (
          <SampleBreakdown authoring />
        ) : (
          <p className="sampling-authoring-denied">This tool is only available to admins.</p>
        )}
      </div>
      <Footer />
    </div>
  );
}
